module.exports = __webpack_public_path__ + "img/Modules.33663c2f.png";